import { createPortal } from "react-dom";
import styles from "../../styles/components/common/ConfirmModal.module.css";

const ConfirmModal = ({ message, onConfirm, onClose }) => {
  return createPortal(
    <div
      className={styles.modalOverlay}
      onClick={onClose}
      onMouseDown={(e) => e.stopPropagation()}
    >
      <div
        className={styles.modalBox}
        onClick={(e) => e.stopPropagation()}
        onMouseDown={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div className={styles.modalHeader}></div>

        {/* Separator line */}
        <div className={styles.modalSeparator}></div>

        {/* Content */}
        <div className={styles.modalContent}>
          <div className={styles.modalText}>
            <p className={styles.modalMessage}>{message}</p>
          </div>
        </div>

        {/* Action buttons */}
        <div className={styles.modalActions}>
          <button type="button" className="buttonSecondary" onClick={onClose}>
            Cancel
          </button>
          <button type="button" className="buttonPrimary" onClick={onConfirm}>
            Confirm
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default ConfirmModal;
